export default "__VITE_ASSET__KwrWLL$t__"